import { z } from 'zod';

export const add = async (sourceSystem: SourceSystem): Promise<boolean> => {
    const res = await fetch(`/SourceSystem`, {
        method: 'POST',
        body: JSON.stringify(sourceSystem),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};

export const all = async (params: object): Promise<SourceSystem[]> => {
    let queryString = '';
    if (params) {
        const paramsAsString = JSON.stringify(params)
            .replace(/:/g, '=')
            .replace(/,/g, '&')
            .replace(/[{}"]/g, '');

        const searchParams = new URLSearchParams(paramsAsString);
        queryString = `?${searchParams.toString()}`;
    }

    const response = await fetch(`/SourceSystem${queryString}`);

    return await response.json();
};

export const update = async (sourceSystem: SourceSystem): Promise<boolean> => {
    const res = await fetch(`/SourceSystem`, {
        method: 'PATCH',
        body: JSON.stringify(sourceSystem),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};
export const SourceSystemSchema = z.object({
    id: z.number().nullable(),
    name: z.string().nonempty({ message: 'A source system name is required.' }),
    slug: z.string().nullable(),
    deletedOn: z.date().nullable(),
});

export type SourceSystem = z.infer<typeof SourceSystemSchema>;